import { render, staticRenderFns } from "./BrokerLogs.vue?vue&type=template&id=765e21c6&scoped=true&"
import script from "./BrokerLogs.vue?vue&type=script&lang=ts&"
export * from "./BrokerLogs.vue?vue&type=script&lang=ts&"
import style0 from "./BrokerLogs.vue?vue&type=style&index=0&id=765e21c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e21c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
